export const validations = {
    // required: (value) => {
    //     return !!value //|| 'required.field';
    // },

    required: (value) => {
        if (typeof value === 'object' && value !== null) {
            return (value.value !== undefined && value.value !== null && value.value !== '') ;
        }
        return (!!value && value !== '') ;
    },

    email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'invalid.email';
    },
    stringValidation(value){
        if (!value) {
            return true;
        }

        let regex = /^[a-zA-Zà-úÀ-ÚÇ0-9\s]+$/;
        if( typeof value === 'string' && regex.test(value) ){
            return true
        } else {
            //return 'invalid.characters.special'
        }
    },
    
    maxLength(value, maxValue){
        if (!value) {
            return true;
        }
        else if(typeof value === 'string' && value.length <= maxValue){
            return true
        } 
        else {
           //return 'label.maximum ' + `${maxValue}` + ' label.characters';
        }
    },

    checkInputLength(input, field, maxLength) {
        if (input[field] && input[field].length > maxLength) {
            input[field] = input[field].slice(0, maxLength);
        }
    },


    cnpj: (value) => {
        if(!value){
            return true;
        }

        let pattern =  /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}\-?\d{2}$/;
        if (!pattern.test(value)) {
            return false; // Formato inválido de CNPJ
        }

        // Verificação do dígito verificador
        value = value.replace(/[^\d]+/g,'');
        if (value.length !== 14) {
            return false;
        }

        // Verificação dos dígitos verificadores
        let tamanho = value.length - 2;
        let numeros = value.substring(0,tamanho);
        let digitos = value.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0)) {
            return false;
        }

        tamanho = tamanho + 1;
        numeros = value.substring(0,tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1)) {
            return false;
        }

        return true; 
    }, 
    
};

export default validations;
